import { render, staticRenderFns } from "./phase-aliases-grid.vue?vue&type=template&id=46ccdf40&"
import script from "./phase-aliases-grid.vue?vue&type=script&lang=ts&"
export * from "./phase-aliases-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports